import Tr from "../../Utils/Translations/Translations";
import "./Footer.scss";
import { AppRoutes } from "../../AppRoutes";
import { ToastMessage } from "../../Utils/UIMessages";
import { Link } from "react-router-dom";
export interface IIFooterData {
  title: string;
  voices: JSX.Element[];
}

export interface IFooterProps {}

const FooterData: IIFooterData[] = [
  {
    title: Tr.Translate("presentation", "footer_about_us"),
    voices: [
      <Link
        to={AppRoutes.MISSION_PAGE}
      >{Tr.Translate("presentation", "footer_our_mission")}</Link>,
      <Link
        to={
          "https://www.portalcloud.org/privacy.html?backUrl=" +
          window.location.origin
        }
      >
        {Tr.Translate("presentation", "footer_privacy")}
      </Link>,
      <Link
        to={
          "https://www.portalcloud.org/terms.html?backUrl=" +
          window.location.origin
        }
      >
        {Tr.Translate("presentation", "footer_term_of_use")}
      </Link>,
    ],
  },
  {
    title: Tr.Translate("presentation", "footer_services"),
    voices: [
      <Link to={AppRoutes.CONTACT_US_PAGE + "?about=support"}>
        {Tr.Translate("presentation", "footer_serv_support")}
      </Link>,
      <Link to={AppRoutes.CONTACT_US_PAGE + "?about=teaching"}>
        {Tr.Translate("presentation", "footer_serv_teaching")}
      </Link>,
      <Link to={AppRoutes.CONTACT_US_PAGE + "?about=private_solutions"}>
        {Tr.Translate("presentation", "footer_serv_private_solutions")}
      </Link>,
    ],
  },
  {
    title: Tr.Translate("presentation", "footer_contact_us"),
    voices: [<div>plotterstudio@portalcloud.org</div>],
  },
  {
    title: Tr.Translate("presentation", "footer_social_media"),
    voices: [
      <div
        onClick={() => {
          ToastMessage("info", Tr.Translate("system", "coming_soon"));
        }}
      >
        {Tr.Translate("presentation", "footer_social_facebook")}
      </div>,
      <div
        onClick={() => {
          ToastMessage("info", Tr.Translate("system", "coming_soon"));
        }}
      >
        {Tr.Translate("presentation", "footer_social_twitter")}
      </div>,
    ],
  },
];

const Footer = (props: IFooterProps) => {
  return (
    <div className="main-footer-wrap">
      {FooterData.map((x: IIFooterData, i: number) => {
        return (
          <div key={i} className="footer-column">
            <div className="footer-title">{x.title}</div>
            {x.voices.map((y: JSX.Element, j: number) => {
              return (
                <div className="footer-label" key={j}>
                  {y}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default Footer;
